const css = () => `.p-tooltip.tooltip-wide {
  max-width: 30rem;

}`;

export default {
  css,
};
